import styled from 'styled-components';
import { TypographyProps, Emphasis, Size, Variant } from './Typography.types';

type FontSizeProps = (theme: any, emphasis: Emphasis, variant: Variant, size: Size) => string;

const getFontStyles: FontSizeProps = (theme, emphasis, variant, size) => {
  if (theme[variant][emphasis]) {
    return theme[variant][emphasis][size];
  }
  return theme[variant][size];
};

const getColorStyles = (theme: any, color: string) => {
  if (theme.text[color]) return theme.text[color];
  return color;
};

export const StyledTypography = styled.span<Required<TypographyProps>>`
  ${({ theme, emphasis, variant, size }) => getFontStyles(theme, emphasis, variant, size)};
  color: ${({ theme, color }) => getColorStyles(theme, color)};
  font-weight: ${({ fontWeight }) => fontWeight};
  margin: 0;
  white-space: pre-line;
`;
